import React, { useEffect, useState } from "react";
import "./disponible.css";
import gand from "../../assets/img_libre/gandhi_gris.png";
import sota from "../../assets/img_libre/sotano_gris.png";
import porr from "../../assets/img_libre/Porrua_gris.png";
import gonv from "../../assets/img_libre/Gonvill_gris.png";

import fondo from "../../assets/img_libre/Fondo_gris.png";
import pendulo from "../../assets/img_libre/Pendulo_gris.png";

import linea from "../../assets/img_libre/linea_disponible.png";
import amaz from "../../assets/img_libre/amazon_gris.png";
import { useTranslation } from "react-i18next";

const Disponible = () => {
  const [lang, setLang] = useState(localStorage.getItem("language") || "es");
  const [langText, setLangText] = useState(
    lang === "es" ? "English" : "Español"
  );
  const [t, i18n] = useTranslation("librBlanc");

  return (
    <div className="disponi">
      <div class="algo">
        <div class=" table">
          <div class="row">
            <div class="LB_titulo">
              <h1>
                <span> {t("header.disponible1")} </span>
              </h1>
            </div>
          </div>

          <div class="row row2">
            <div class="container">
              <img class="imagen" src={gand} alt="Gandhi" />
              <a
                href="https://www.elsotano.com/libro/ideas-sobre-la-libertad-que-cambian-al-mundo-2-ed_10611216"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img class="imagen" src={sota} alt="El Sótano" />
              </a>
              <img class="imagen" src={porr} alt="Imagen 3" />
              <a
                href="https://www.gonvill.com.mx/libro/ideas-sobre-la-libertad-que-cambian-al-mundo_43660002"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img class="imagen" src={gonv} alt="Gonvill" />
              </a>
              <img
                class="imagen"
                src={fondo}
                alt="Fondo de cultura económica"
              />
              <img class="imagen" src={pendulo} alt="El Péndulo" />
            </div>
          </div>

          <div class="row">
            <img class="LB_lib1" src={linea} />
          </div>

          <div class="row">
            <div class="LB_titulo2">
              <h1>
                <span> {t("header.disponible2")} </span>
              </h1>
            </div>
          </div>

          <div class="row">
            <div class="container2">
              <a
                href="https://www.amazon.com.mx/Ideas-sobre-libertad-cambian-mundo-ebook/dp/B09HX3BG8T/ref=tmm_kin_swatch_0?_encoding=UTF8&qid=1703270322&sr=8-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img class="imagen" src={amaz} alt="Amazon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disponible;
